import { getStateAtNamespaceKey } from 'redux/get-state-at-namespace-key';
import { FavouritesExperienceState } from 'redux/modules/favourites-experience/types';

export const getBoughtInStore = (state: WtrState) =>
  getStateAtNamespaceKey(state, 'boughtInStore') as FavouritesExperienceState;
